<template>
  <div id="preview-map" class="location" data-latitude="0" data-longitude="0">
    <img class="location__map" :src="azureImage" alt="Azure Image" />
    <div
      class="modal fade lg entity-modal entity-modal_fullheight--md"
      id="room-display-map"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content modal-map-poi">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span></span>
            <span></span>
          </button>
          <div class="modal-header bg-color-white px-8">
            <p class="h5 modal-title color-black text-bold">
              {{ title }}
            </p>
          </div>
          <div class="modal-body position-relative">
            <div id="room-display-hotel-map"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { assetsUrl, apiKeyAzure, apiSignature } from '@/infrastructure/Configuration'
import { signUrl } from '@/infrastructure/urlSigner'

export default {
  name: 'AzurePreviewMap',
  props: {
    title: {
      type: String,
      default: ''
    },
    marker: {
      type: String,
      default: 'marker'
    },
    coordinates: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      azureImage: ''
    }
  },
  async mounted() {
    const { latitude = 0, longitude = 0 } = this.coordinates
    const mapMarkerIcon = `${assetsUrl}/img/icons/markers/${this.marker || 'marker'}.png`

    if (!latitude || !longitude) {
      console.warn('Invalid coordinates for AzurePreviewMap')
      return
    }

    const unsignedUrl = `https://atlas.microsoft.com/map/static?api-version=2024-04-01&tilesetId=microsoft.base.road&zoom=13&center=${longitude},${latitude}&height=250&width=310&pins=default|coE94234||${longitude} ${latitude}||&subscription-key=${apiKeyAzure}`
    this.azureImage = await signUrl(unsignedUrl, apiSignature)

    global._loadMapsScript(() => {
      global.$('.location').on('click', function () {
        global.$('#room-display-map').modal('show')
      })

      global.$('#room-display-map').on('show.bs.modal', () => {
        const map = new global.MapControl('#room-display-hotel-map', {
          center: { latitude, longitude },
          zoom: 13
        })
        const hotelMarker = global.MapControl.buildMarker({ latitude, longitude }, mapMarkerIcon)
        map.setMarker(hotelMarker)

        map.map.events.add('ready', () => {
          const atlasControl = global.atlas.control
          if (atlasControl) {
            map.map.controls.add(new atlasControl.ZoomControl(), { position: 'bottom-right' })
            map.map.controls.add(new atlasControl.FullscreenControl(), { position: 'top-right' })
            map.map.controls.add(new atlasControl.StyleControl(), { position: 'top-left' })
          } else {
            console.warn('Azure Maps controls not available.')
          }
        })

        global.$('#room-display-map').off('show.bs.modal')
      })
    })
  },
  beforeDestroy() {
    global.$('#room-display-map').off('show.bs.modal')
    global.$('.location').off('click')
  }
}
</script>

<style scoped>
.location {
  height: 250px;
  cursor: pointer;
}
img {
  height: 250px !important;
  width: 100%;
  object-fit: cover;
}
</style>
